import Layout from "components/Layout";
import React from "react";
import LibraryDataTable from "./components/LibraryDataTable";

function Library() {
  return (
    <Layout title="라이브러리 목록">
      <LibraryDataTable />
    </Layout>
  );
}

export default Library;
